<article
    class="bg-base-100 border border-neutral-200 rounded-md w-full bg-white"
>
    @if (!sub()) {
        @if (!image()) {
            <div class="flex w-full justify-between items-center p-6 border-b">
                <div class="min-w-max">
                    <ng-container *ngTemplateOutlet="titleSection" />
                </div>
                <ng-container *ngTemplateOutlet="buttonSection" />
            </div>
        }
    }
    <div class="flex flex-col gap-8 justify-center w-full h-full p-6">
        @if (image(); as src) {
            <div class="flex flex-col gap-8 items-center">
                <ng-container *ngTemplateOutlet="buttonSection" />
                <app-article-image [src]="src" [expand]="imageExpand()" />
                <ng-container *ngTemplateOutlet="titleSection" />
            </div>
        }
        <div id="content" class="flex flex-col gap-8 w-full">
            <ng-content />
        </div>
    </div>
</article>

<ng-template #buttonSection>
    <div id="buttons" class="flex w-full justify-end">
        <ng-content select="[buttons]" />
        <ng-content select="[button]" />
    </div>
</ng-template>

<ng-template #titleSection>
    <div class="flex gap-3 items-center">
        <p id="title" class="text-xl font-semibold text-zinc-800">
            <ng-content select="[title]" />
            @if (title()) {
                {{ title() }}
            }
        </p>
        <div id="badge" class="*:flex *:gap-3 *:items-center">
            <ng-content select="[badges]" />
            <ng-content select="[badge]" />
        </div>
    </div>
</ng-template>
